import axios from 'axios';
import Cookies from 'js-cookie';
import { TOKEN_NAME } from '../constants';
import { mockApiRequest, isDemoMode } from './mockApi';

export default async function (endpoint, opts) {
  // In demo mode, intercept and return mock data
  if (isDemoMode) {
    return await mockApiRequest(endpoint, opts);
  }

  // Normal production/dev flow
  const { headers, ...options } = opts;
  const config = Object.assign(
    {
      url: endpoint,
      baseURL: process.env.REACT_APP_API_URI,
      headers: Object.assign(
        {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get(TOKEN_NAME)}`,
        },
        headers,
      ),
      timeout: 60000,
    },
    options,
  );
  try {
    const response = await axios.request(config);
    return { response: response.data || {} };
  } catch (error) {
    if (error.response) {
      const status = error.response.status || error.request?.status;
      // Expired / invalid session: the auth cookie can lapse while the page
      // stays open, so a later request sends `Bearer undefined` → 401. Instead
      // of a confusing "Unauthorized" toast on a stale page (which reads like a
      // broken feature), clear the dead session and send the user to re-login.
      // Skip when the failing call IS an auth endpoint (a 401 there is a real
      // credentials error the form should show) or we're already on a login
      // page (no redirect loop).
      if (status === 401) {
        const isAuthCall = /\/auth\/(login|admin-login|2fa)/.test(endpoint || '');
        const onLoginPage = /\/(login|admin-login)(\/|$)/.test(window.location.pathname);
        if (!isAuthCall && !onLoginPage) {
          Cookies.remove(TOKEN_NAME, { path: '/' });
          window.location.assign('/login');
        }
      }
      return {
        error: Object.assign(error.response.data, {
          status,
        }),
      };
    }
    if (error.request && error.request._response) {
      return { error: { message: error.request._response } };
    }
    return { error: { message: error.message } };
  }
}
